"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var richEdit = require("./rich-edit");
var events = require("./events");
var options = require("./options");
var DevExpress = window.DevExpress = window.DevExpress || {};
DevExpress.RichEdit = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, richEdit), events), options);
tslib_1.__exportStar(require("./rich-edit"), exports);
tslib_1.__exportStar(require("./events"), exports);
tslib_1.__exportStar(require("./options"), exports);
